{
  "confluence-integrations.confluence-connector-request-fulfilled.email.action": [
    {
      "type": 0,
      "value": "Finish Connecting"
    }
  ],
  "confluence-integrations.confluence-connector-request-fulfilled.email.body.generic": [
    {
      "type": 0,
      "value": "You can now connect your workspace to your requested app!"
    }
  ],
  "confluence-integrations.confluence-connector-request-fulfilled.email.body.named": [
    {
      "type": 0,
      "value": "You can now connect your workspace to "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "confluence-integrations.confluence-connector-request-fulfilled.email.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "confluence-integrations.confluence-connector-request-fulfilled.email.heading": [
    {
      "type": 0,
      "value": "Your connection request was approved!"
    }
  ],
  "confluence-integrations.confluence-connector-request-fulfilled.email.subject": [
    {
      "type": 0,
      "value": "Your connection request was approved"
    }
  ],
  "confluence-integrations.confluence-devdocs-sync-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Docs created from your code are ready"
    }
  ],
  "confluence-integrations.confluence-editor-smart-folder-paste-nudge.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "confluence-integrations.confluence-editor-smart-folder-paste-nudge.description": [
    {
      "type": 0,
      "value": "Create a Confluence folder that syncs to your external folder."
    }
  ],
  "confluence-integrations.confluence-editor-smart-folder-paste-nudge.done": [
    {
      "type": 0,
      "value": "Create a synced folder"
    }
  ],
  "confluence-integrations.confluence-editor-smart-folder-paste-nudge.title": [
    {
      "type": 0,
      "value": "Bring your work into this space"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.explanation": [
    {
      "type": 0,
      "value": "With this access, JSM users (who may or may not be licensed Confluence users) can view and potentially create and edit content in Confluence -- but only in specific spaces that are explicitly linked to JSM projects."
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.farewell-line-one": [
    {
      "type": 0,
      "value": "Thanks,"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.farewell-line-two": [
    {
      "type": 0,
      "value": "the Confluence team"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.global-permissions": [
    {
      "type": 0,
      "value": "Confluence site's global permissions"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "username"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.header-summary": [
    {
      "children": [
        {
          "type": 0,
          "value": "Admin notification"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": JSM Access is turned on for "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "0"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.subject": [
    {
      "type": 0,
      "value": "Admin notification: JSM Access is turned on for "
    },
    {
      "type": 1,
      "value": "0"
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.view-info": [
    {
      "type": 0,
      "value": "You can view and remove this access in the JSM Access tab of your "
    },
    {
      "type": 1,
      "value": "globalPermissionsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "confluence-integrations.confluence-jsm-access.message-template.email.your-confluence-site": [
    {
      "type": 0,
      "value": "Your Confluence site "
    },
    {
      "type": 1,
      "value": "confluenceLink"
    },
    {
      "type": 0,
      "value": " has the Jira Service Management (JSM) access global setting turned on. This helps JSM teams manage their knowledge base needs by using JSM and Confluence together."
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.body": [
    {
      "type": 0,
      "value": "You started connecting "
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": " in Confluence but did not finish."
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.cta": [
    {
      "type": 0,
      "value": "Finish connecting"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.subject": [
    {
      "type": 0,
      "value": "Finish connecting "
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": " in Confluence"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.unsubscribe": [
    {
      "type": 0,
      "value": "Manage email preferences"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.notification-drawer.connect": [
    {
      "type": 0,
      "value": "Connect"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.notification-drawer.title": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "providerName"
    },
    {
      "type": 0,
      "value": " to see previews"
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.body": [
    {
      "type": 0,
      "value": "Pages is now Docs. Access pages, live docs, and more, all from your space."
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.heading": [
    {
      "type": 0,
      "value": "One place for all your project docs"
    }
  ]
}